import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrandSelectionComponent } from './brand-selection/brand-selection.component';
import { LoaderComponent } from './loader/loader.component';
import { ReactiveFormsModule } from '@angular/forms';


@NgModule({
  declarations: [
    BrandSelectionComponent,
    LoaderComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
  ],
  exports: [
    BrandSelectionComponent,
    LoaderComponent
  ]
})
export class CommonComponentModule { }
